// extracted by mini-css-extract-plugin
export default {"melodyVideo":"VI-z","isFullWidth":"WI-z","landingPageVideo":"XI-z","play":"YI-z","iframeVideo":"ZI-z","playHidden":"_I-z","fullwidth":"aJ-z"};